import type { SectionType } from '~/utils/api/common';

export const calculateSectionLink = (section: SectionType) => {
  let result = section.code;

  let currentCategory = section;
  let counter = 0;

  while (currentCategory.parent) {
    const prevCategory = currentCategory.parent;
    result = `${prevCategory.code}/${result}`;
    currentCategory = prevCategory;

    counter += 1;
    if (counter > 100) throw createError({ statusCode: 500 });
  }

  return `/catalog/${result}`;
};
